<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tnij7A/tc-custom/9781488079085.jpg?1705026267491" alt="This image is the cover for the book Sunset Promises, Cheyenne Nights"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sunset Promises, Cheyenne Nights
      </h1>
      <p class="bookDescription body article font2">
        <i>Read this classic romance by </i>New York Times<i> bestselling author Carla Cassidy!</i><br/><br/>Seized by vise-like contractions, Colette Connor prayed she wasn't going to deliver on the Connor ranch doorstep. With no recollection of who she is or how she got pregnant, she has nowhere else to turn. Only the knowing eyes and the incendiary kisses of stranger Hank Cooper disturb her more. <br/><br/>With the keen instincts of a professional bodyguard, Hank had anticipated Colette's arrival. But he wasn't prepared for her amnesia—or the baby. While her missing memories might help protect her from a killer, they're defenseless against Hank, who is the only man who holds the answers to all her questions…and more. <br/><br/>Originally published in 1997
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Cassidy
      </h2>
      
      <p class="authorDescription body article">Carla Cassidy is a <I>New York Times </I>bestselling&#160;author who has written more than 125 novels for Harlequin Books.&#160; She is listed on the Romance Writer&#39;s of America Honor Roll and has won numerous awards. Carla believes the only thing better than curling up with a good book to read is sitting down at the computer with a good story to write.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b18ba23a